import { scenariosData } from '@/mocks/home';

export default function ScenariosSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            luluca 的使用场景
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            无论你从事什么行业，luluca 都能帮你高效完成创作任务
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {scenariosData.map((scenario) => (
            <div
              key={scenario.id}
              className="bg-background-50 rounded-2xl p-6 md:p-7 text-center hover:shadow-md transition-shadow duration-300"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-5">
                <i className={`${scenario.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">
                {scenario.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {scenario.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}